"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Col = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lib = require("./lib");

var _style = require("./style");

/**
 * The column of the Sheet.
 *
 * ```js
 * const col = sheet.col(0);
 * col.width = 20;
 * col.style.fill.patternType = 'solid';
 * col.style.fill.fgColor = '00FF0000';
 * col.style.fill.bgColor = 'FF000000';
 * col.style.align.h = 'center';
 * col.style.align.v = 'center';
 * ```
 */
var Col = /*#__PURE__*/function () {
  /**
   * Number format for all column @see {@link NumFmt}
   * @type {String}
   */
  function Col(_ref) {
    var min = _ref.min,
        max = _ref.max,
        _ref$hidden = _ref.hidden,
        hidden = _ref$hidden === void 0 ? false : _ref$hidden,
        _ref$collapsed = _ref.collapsed,
        collapsed = _ref$collapsed === void 0 ? false : _ref$collapsed,
        _ref$width = _ref.width,
        width = _ref$width === void 0 ? 0 : _ref$width;
    (0, _classCallCheck2.default)(this, Col);
    (0, _defineProperty2.default)(this, "outlineLevel", 0);
    (0, _defineProperty2.default)(this, "numFmt", '');
    this.min = min;
    this.max = max;
    this.hidden = hidden;
    this.collapsed = collapsed;
    /**
     * Column width [default 9.5]
     * @type {Number}
     */

    this.width = width;
    /**
     * Style of the column.
     * @type {Style}
     */

    this.style = new _style.Style();
  }

  (0, _createClass2.default)(Col, [{
    key: "setType",
    value: function setType(cellType) {
      this.numFmt = _lib.NumFmt[cellType];
    }
  }]);
  return Col;
}();

exports.Col = Col;